<div [ngClass]="{ 'p-6': !isHandset() }">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
        @if (isHandset()) {
        <h3 class="text-lg font-semibold text-gray-900">Groups Management</h3>
        } @else {
        <h1 class="text-2xl font-semibold text-gray-900">Groups Management</h1>
        }

        <!-- Role filter -->
        <mat-form-field class="min-w-[160px]">
            <mat-label>Role</mat-label>
            <mat-select [(ngModel)]="selectedRole" (ngModelChange)="onFilterChange()">
                <mat-option [value]="undefined">All Roles</mat-option>
                @for (role of roles; track role) {
                <mat-option [value]="role">{{ role }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <!-- Loading -->
    @if (isLoading()) {
    <div class="flex flex-col items-center justify-center py-12 space-y-4">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="text-gray-500">Loading groups...</p>
    </div>
    } @else if (hasGroups) {
    <!-- Expansion panels per customer -->
    <mat-accordion multi>
        @for (section of groupsByCustomer(); track section.customerId) {
        <mat-expansion-panel expanded class="mb-3">
            <mat-expansion-panel-header class="!bg-gray-50">
                <mat-panel-title class="font-semibold text-gray-800">
                    <mat-icon class="mr-2 text-gray-500"
                        style="font-size:18px;width:18px;height:18px">business</mat-icon>
                    {{ section.customerName }}
                </mat-panel-title>
                <mat-panel-description class="text-gray-400">{{ section.groups.length }} group{{ section.groups.length
                    === 1 ? '' : 's' }}</mat-panel-description>
            </mat-expansion-panel-header>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-4">
                @for (group of section.groups; track group.id) {
                <app-group-item [group]="group" (assignParkingSpace)="onAssignParkingSpace($event)"
                    (unassignParkingSpace)="onUnassignParkingSpace($event)" (addOperator)="onAddOperator($event)"
                    (memberRemoved)="loadGroups()">
                </app-group-item>
                }
            </div>
        </mat-expansion-panel>
        }
    </mat-accordion>
    } @else {
    <jjames-card class="text-center py-12">
        <div class="flex flex-col items-center space-y-4">
            <mat-icon class="text-gray-400" style="font-size:64px;height:64px;width:64px">group_work</mat-icon>
            <div class="space-y-2">
                <h3 class="text-lg font-medium text-gray-900">No groups found</h3>
                <p class="text-gray-500 max-w-sm">No operator groups match your current filters.</p>
            </div>
        </div>
    </jjames-card>
    }
</div>